import moment from 'moment'

import { sortTickets } from '../../utilities/helpers'

import Form from 'react-bootstrap/Form'
import Table from 'react-bootstrap/Table'

export default function ResultsTable({ results }) {
  const sortedResults = results?.sort(
    (a, b) => new Date(a.event.start) - new Date(b.event.start)
  )

  const formatTR = (result) => {
    return (
      <>
        {sortTickets(result?.tickets).map((tic, idx) => (
          <tr key={idx}>
            <td>
              <Form.Check // prettier-ignore
                type={'checkbox'}
                id={`default-checkbox`}
                className="checkbox"
                label={``}
                disabled={tic?.was_scanned ? true : false}
                data-event={result?.event.uuid}
                data-eventname={result?.event.name}
                data-eventdate={moment(result?.event.start).format(
                  'MM/DD/YYYY'
                )}
                data-ticket={tic.uuid}
                data-ticket-id={tic.id}
                data-sectionnumber={tic.section_number}
                data-rownumber={tic.row_number}
                data-seatnumber={tic.seat_number}
                data-generaladmission={tic.general_admission}
                data-user-email={result?.orderMeta?.email}
                data-order-id={result?.orderMeta?.orderId}
              />
            </td>
            <td>{result?.orderMeta?.email}</td>
            <td>{tic?.section_number}</td>
            <td>{tic?.row_number || '--'}</td>
            <td>{tic?.seat_number || '--'}</td>
            <td>{tic?.was_scanned ? 'true' : 'false'}</td>
          </tr>
        ))}
      </>
    )
  }

  return (
    <>
      <Table striped hover className="mt-3">
        <tbody>
          {sortedResults.map((result, index) => (
            <>
              <tr eventUUID={result?.event?.uuid} key={index}>
                <th colSpan={6} className="text-center">
                  {result?.event?.name} -{' '}
                  {moment(result?.event?.start).format('MM/DD/YYYY')}
                </th>
              </tr>
              <tr>
                <th>Select</th>
                <th>Email</th>
                <th>Section</th>
                <th>Row</th>
                <th>Seat</th>
                <th>Scanned</th>
              </tr>
              {formatTR(result)}
            </>
          ))}
        </tbody>
      </Table>
    </>
  )
}
